import { api } from "./api";

const p = (path) => `/workbook${path}`;

export const listWorkbookEntries = async (params = {}) =>
  (await api.get(p("/entries"), { params })).data;

export const getWorkbookEntry = async (id) =>
  (await api.get(p(`/entries/${id}`))).data;

export const createWorkbookEntry = async (payload) =>
  (await api.post(p("/entries"), payload)).data;

export const updateWorkbookEntry = async (id, patch) =>
  (await api.patch(p(`/entries/${id}`), patch)).data;

export const duplicateWorkbookEntry = async (id, body = {}) =>
  (await api.post(p(`/entries/${id}/duplicate`), body)).data;

export const deleteWorkbookEntry = async (id) =>
  (await api.delete(p(`/entries/${id}`))).data;
